import React, {useCallback, useState} from 'react';
import {RowWrapper} from '../style';
import {Td as TableTd} from '#app/components/Table/styles';
import {OperationSizeConstants} from '#app/pages/IncomeAndExpenses/components/BaseOperationList/OperationSizeConstants';
import {Api} from 'laravel-request';

// Подключаемые части
import {
    SubCategoryDisplay
} from '#app/pages/IncomeAndExpenses/components/BaseOperationList/ItemParts/SubCategoryDisplay';
import {AccountDisplay} from '#app/pages/IncomeAndExpenses/components/BaseOperationList/ItemParts/AccountDisplay';
import {DescDisplay} from '#app/pages/IncomeAndExpenses/components/BaseOperationList/ItemParts/DescDisplay';
import {TagDisplay} from '#app/pages/IncomeAndExpenses/components/BaseOperationList/ItemParts/TagDisplay';
import {CategoryDisplay} from '#app/pages/IncomeAndExpenses/components/BaseOperationList/ItemParts/CategoryDisplay';
import {SumDisplay} from '#app/pages/IncomeAndExpenses/components/BaseOperationList/ItemParts/SumDisplay';
import {
    RelationSumDisplay
} from '#app/pages/IncomeAndExpenses/components/BaseOperationList/ItemParts/RelationSumDisplay';
import {EditIcon} from '#app/pages/IncomeAndExpenses/components/BaseOperationList/ItemParts/EditIcon';

const Item = ({
                  item,
                  year,
                  month,
                  date,
                  currencyId,
                  isNotVisibleSum,
                  handleClick,
                  types,
                  subcategories,
                  tags,
                  subcategoryType,
                  customTypeId,
                  detachCallback,
              }) => {
    const [hovered, setHovered] = useState(false);

    const onMouseEnter = useCallback(() => setHovered(true), []);
    const onMouseLeave = useCallback(() => setHovered(false), []);

    const handleDetach = useCallback(() => {
        Api.post('active-connected-operation', 'detach', {
            active_id: item.id,
        }).call(
            (response) => {
                detachCallback?.(item);
            },
            () => {
                // Можно добавить обработку ошибок
            }
        );
    }, [item, detachCallback]);

    return (
        <RowWrapper
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            id={`operation-${item.id}`}
        >
            <TableTd flexWidth="2%" />
            <TableTd flexWidth={OperationSizeConstants.dateCellWidth} />
            <TableTd flexWidth={OperationSizeConstants.editCellWidth}>
                <EditIcon hovered={hovered} handleClick={handleClick} item={item} />
            </TableTd>
            <TableTd border flexWidth={OperationSizeConstants.sumCellWidth}>
                <SumDisplay item={item} isNotVisibleSum={isNotVisibleSum} currencyId={currencyId} />
                <RelationSumDisplay item={item}/>
            </TableTd>
            <TableTd border flexWidth={OperationSizeConstants.categoryCellWidth}>
                <CategoryDisplay item={item} types={types} customTypeId={customTypeId} />
            </TableTd>
            <TableTd border flexWidth={OperationSizeConstants.subcategoryCellWidth}>
                <SubCategoryDisplay item={item} subcategoryType={subcategoryType} subcategories={subcategories} />
            </TableTd>
            <TableTd border flexWidth={OperationSizeConstants.tagCellWidth}>
                <TagDisplay item={item} subcategoryType={subcategoryType} tags={tags} />
            </TableTd>
            <TableTd border flexWidth={OperationSizeConstants.descCellWidth}>
                <DescDisplay item={item} isNotVisibleSum={isNotVisibleSum} />
            </TableTd>
            <TableTd border flexWidth={OperationSizeConstants.accountCellWidth}>
                <AccountDisplay item={item} year={year} month={month} date={date} fullAccountName={item.account?.name} />
            </TableTd>
        </RowWrapper>
    );
};

export default Item;